import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { InlineEdit } from '@/components/recipe/inline-edit'

interface RecipeNotesCardProps {
  notes?: string
  isInlineEditMode: boolean
  onInlineUpdate: (field: string, value: unknown) => Promise<boolean>
}

export function RecipeNotesCard({ notes, isInlineEditMode, onInlineUpdate }: RecipeNotesCardProps) {
  if (!notes && !isInlineEditMode) {
    return null
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Notities</CardTitle>
      </CardHeader>
      <CardContent>
        {isInlineEditMode ? (
          <InlineEdit
            value={notes || ''}
            onSave={(value) => onInlineUpdate('notes', value)}
            placeholder="Voeg notities toe..."
            multiline
          />
        ) : (
          <div className="rounded-r-lg border-l-4 border-blue-400 bg-blue-50 p-4">
            <p className="text-blue-800">{notes}</p>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
